var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('label',{staticClass:"switch"},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.is_code_theme_dark},on:{"change":_vm.switch_code_theme}}),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"slider round"},[_c('i',{staticClass:"fas fa-moon"}),_c('i',{staticClass:"fas fa-sun"})])
}]

export { render, staticRenderFns }